import { useQuery } from 'react-query';
import { InputLabel, FormControlLabel, Checkbox, Grid, TextField } from '@mui/material';
import { formatInputPhoneNumber } from '../../../helpers';
import { IDropdownResponse } from '../../../models';
import { getCustomRoles } from '../../../fetch';

export const CustomsFields = ({
  setFieldValue,
  values,
  isFormDisabled,
  touched,
  errors,
  handleBlur
}) => {
  const { isLoading: isLoadingCustomRoles, data: customRoles } = useQuery<
    IDropdownResponse[],
    Error
  >(['custom-roles'], () => getCustomRoles());
  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          onChange={e => setFieldValue('email', e.target.value)}
          error={touched.email && errors && errors.email ? true : false}
          helperText={touched.email && errors && errors.email}
          fullWidth={true}
          id="email"
          label="Email (Username)"
          size="small"
          name="email"
          onBlur={handleBlur}
          required={true}
          autoComplete="off"
          value={values.email}
          disabled={isFormDisabled}
          inputProps={{
            'data-lpignore': true // Last Pass disable auto-fill
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          autoComplete="nope"
          label="First Name"
          name="firstName"
          value={values.firstName}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          inputProps={{
            'data-lpignore': 'true'
          }}
          error={touched.firstName && errors && errors.firstName ? true : false}
          helperText={touched.firstName && errors && errors.firstName}
          onChange={e => setFieldValue('firstName', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          autoComplete="nope"
          label="Last Name"
          name="lastName"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.lastName}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.lastName && errors && errors.lastName ? true : false}
          helperText={touched.lastName && errors && errors.lastName}
          onChange={e => setFieldValue('lastName', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          onChange={e => setFieldValue('workplace', e.target.value)}
          fullWidth={true}
          id="workplace"
          label="Workplace"
          size="small"
          required={true}
          autoComplete="off"
          value={values.workplace}
          disabled={isFormDisabled}
          inputProps={{
            'data-lpignore': true // Last Pass disable auto-fill
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          autoComplete="nope"
          label="Phone Number"
          name="phone"
          value={values.phoneNumber}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          onChange={e => {
            setFieldValue('phoneNumber', formatInputPhoneNumber(e.target.value));
          }}
          error={Boolean(touched.phoneNumber && errors.phoneNumber)}
          helperText={touched.phoneNumber && errors.phoneNumber}
        />
      </Grid>
      {!isLoadingCustomRoles && (
        <Grid item xs={12}>
          <InputLabel id="state">Roles</InputLabel>
          {customRoles.map((customRole, index) => {
            return (
              <FormControlLabel
                key={`${index}`}
                color="primary"
                control={
                  <Checkbox
                    checked={values.roles?.includes(customRole.value) ?? false}
                    id={`roles-${index}`}
                    onChange={(_, checked) =>
                      values.roles?.includes(customRole.value)
                        ? setFieldValue(
                            'roles',
                            values.roles?.filter(role => role !== customRole.value)
                          )
                        : setFieldValue('roles', [...values.roles, customRole.value])
                    }
                  />
                }
                label={customRole.description}
              />
            );
          })}
        </Grid>
      )}
    </>
  );
};
